import { render } from "./CartItemModal.vue?vue&type=template&id=13499f25&scoped=true&ts=true"
import script from "./CartItemModal.vue?vue&type=script&lang=ts"
export * from "./CartItemModal.vue?vue&type=script&lang=ts"

import "./CartItemModal.vue?vue&type=style&index=0&id=13499f25&scoped=true&lang=css"

import exportComponent from "/home/runner/work/bakery-platform/bakery-platform/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13499f25"]])

export default __exports__